<div class="flex-grow flex-shrink basis-full flex flex-col">
  <div
    class="flex flex-grow flex-wrap md:flex-row flex-col gap-x-6 content-start"
  >
    <ng-container *ngFor="let criterion of availableCriteria">
      <report-criteria-item
        *ngIf="criterion.used"
        [formGroup]="criteriaForm"
        [criteriaItem]="criterion"
      ></report-criteria-item>
    </ng-container>
  </div>

  <div fxLayout="row" fxLayoutAlign="start center" class="add-parameter">
    <button
      mat-stroked-button
      color="primary"
      [matMenuTriggerFor]="menu"
      type="button"
    >
      Add Parameter
    </button>
  </div>
  <mat-menu #menu="matMenu">
    <button
      type="button"
      mat-menu-item
      *ngFor="let criterion of availableCriteria"
      [disabled]="criterion.used"
      (click)="useCriterion(criterion)"
    >
      {{ criterion.name }}
    </button>
  </mat-menu>
</div>
